(() => {
  if (window.GremariCartPageLoaded) return;
  window.GremariCartPageLoaded = true;

  const root = () => document.querySelector('[data-gm-cart-page]');

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        { style: 'currency', currency: currency || 'EUR' }
      ).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency || ''}`.trim();
    }
  }

  function setBusy(item, busy) {
    item?.classList.toggle('gm-is-updating', busy);
    item?.querySelectorAll('button').forEach(btn => btn.disabled = busy);
  }

  async function update(key, quantity, item) {
    if (!key) return;
    setBusy(item, true);

    const errorBox = item?.querySelector('[data-gm-cart-item-error]');
    if (errorBox) errorBox.textContent = '';

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity })
      });

      if (!res.ok) throw new Error(`Cart update failed (${res.status})`);

      const cart = await res.json();
      const line = cart.items.find(i => i.key === key);

      if (!line || quantity === 0) {
        item?.remove();
      } else {
        const qtyWrap = item?.querySelector('[data-gm-cart-qty]');
        if (qtyWrap) qtyWrap.dataset.currentQuantity = line.quantity;

        const qtyValue = item?.querySelector('[data-gm-cart-qty-value]');
        if (qtyValue) qtyValue.textContent = line.quantity;

        const price = item?.querySelector('[data-gm-cart-line-price]');
        if (price) price.textContent = money(line.final_line_price, cart.currency);
      }

      document.querySelectorAll('[data-gm-cart-total]').forEach(el => {
        el.textContent = money(cart.total_price, cart.currency);
      });

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      document.dispatchEvent(new CustomEvent('gremari:cart:updated', { detail: cart }));
    } catch (error) {
      console.error('[GREMARI cart]', error);
      if (errorBox) {
        errorBox.textContent = 'Could not update the cart. Please try again.';
      }
    } finally {
      setBusy(item, false);
    }
  }

  document.addEventListener('click', event => {
    const minus = event.target.closest('[data-gm-cart-minus]');
    const plus = event.target.closest('[data-gm-cart-plus]');
    const remove = event.target.closest('[data-gm-cart-remove]');

    if (!minus && !plus && !remove) return;

    const item = event.target.closest('[data-gm-cart-item]');
    const key = item?.dataset.cartKey;
    if (!key) return;

    if (remove) {
      event.preventDefault();
      update(key, 0, item);
      return;
    }

    const qtyWrap = event.target.closest('[data-gm-cart-qty]');
    const current = Number(qtyWrap?.dataset.currentQuantity || 1);
    const next = minus ? Math.max(0, current - 1) : current + 1;

    event.preventDefault();
    update(key, next, item);
  });
})();
